import * as types from '../mutation-types'
import moment from 'moment'

const state = {
	all: [],
	active: {
		id: null,
		winemaker_id: null,
		wine_name: '',
		duration: null,
		type: false,
		style: true,
		start_date: moment().format('DD/MM/YYYY hh:mm A'),
		juiceAnalysis: {
			data: {}
		},
		dailyData: {
			data: []
		}
	},
	graphBase64: null
}

const mutations = {
	[types.SET_FERMENTS](state, ferments) {
		state.all = ferments;
	},
	[types.SET_ACTIVE_FERMENT](state, ferment) {
		state.active = ferment;
	},
	[types.SET_GRAPH_BASE64](state, base64) {
		state.graphBase64 = base64;
	}
}

export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/ferments.js